import axiosInstance from '../axiosInstance';

class PasswordService {
  static async changePassword(currentPassword, newPassword, confirmPassword) {
    if (!currentPassword?.trim() || !newPassword?.trim() || !confirmPassword?.trim()) {
      throw new Error('All password fields are required');
    }

    if (newPassword !== confirmPassword) {
      throw new Error('New passwords do not match');
    }

    if (newPassword.length < 6) {
      throw new Error('Password must be at least 6 characters long');
    }

    try {
      const requestData = {
        current_password: currentPassword.trim(),
        new_password: newPassword.trim(),
        new_password_confirmation: confirmPassword.trim(),
      };

      const { data } = await axiosInstance.post('/auth/password/change', requestData);
      return data;
    } catch (error) {
      console.error('Change password error:', error);
      throw error;
    }
  }

  static async initiatePasswordReset(identifier) {
    if (!identifier?.trim()) {
      throw new Error('Email address is required');
    }

    try {
      const requestData = {
        identifier: identifier.trim(),
      };

      const { data } = await axiosInstance.post('/auth/password/forgot', requestData);
      return data;
    } catch (error) {
      console.error('Initiate password reset error:', error);
      throw error;
    }
  }

  static async resetPassword(pin, password, confirmPassword) {
    if (!pin?.trim() || !password?.trim() || !confirmPassword?.trim()) {
      throw new Error('All fields are required');
    }

    if (password !== confirmPassword) {
      throw new Error('Passwords do not match');
    }

    if (password.length < 6) {
      throw new Error('Password must be at least 6 characters long');
    }

    if (pin.length !== 6 || !/^\d{6}$/.test(pin)) {
      throw new Error('PIN must be 6 digits');
    }

    try {
      const requestData = {
        pin: pin.trim(),
        password: password.trim(),
        password_confirmation: confirmPassword.trim(),
      };

      const { data } = await axiosInstance.post('/auth/password/reset', requestData);
      return data;
    } catch (error) {
      console.error('Reset password error:', error);
      throw error;
    }
  }
}

export default PasswordService;